module.exports = __webpack_public_path__ + "static/media/amazon.bab2b992.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/imgs/channel/amazon.png
// module id = 419
// module chunks = 0